import { render, staticRenderFns } from "./AddNewBooking.vue?vue&type=template&id=53c7d172"
import script from "./AddNewBooking.js?vue&type=script&lang=js&external"
export * from "./AddNewBooking.js?vue&type=script&lang=js&external"
import style0 from "./AddNewBooking.vue?vue&type=style&index=0&id=53c7d172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports